import React, { useState } from 'react'
import { Divider } from 'antd';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';

import Button from "../../../../../../components/uiComponent/button";
import ReactSelect from '../../../../../../components/uiComponent/select';

import { StepFourWrapper } from '../style';
import { useDispatch, useSelector } from 'react-redux';
import { DownloadBillOfLading, GetLabels } from '../../../../../../slices/post-shipment';
import PackScanModal from './PackScanModal';

const StepFour = ({
  printBoxGlobal,
  shipments,
  shipmentType,
  packingMethod,
  transportationDetails = []
}) => {

  const [getBoxLabelsLoading, setGetBoxLabelsLoading] = useState(false);
  const [getCarrierLabelsLoading, setGetCarrierLabelsLoading] = useState(false);
  const [getPalletLabelsLoading, setGetPalletLabelsLoading] = useState(false);
  const [palletsLoading, setPalletsLoading] = useState({});
  const [allBolLoading, setAllBolLoading] = useState({});
  const [boxLabelPageType, setBoxLabelPageType] = useState('PackageLabel_Letter_6');
  const [palletLabelPageType, setPalletLabelPageType] = useState('PackageLabel_Thermal_NonPCP');
  const [packScanVisible, setPackScanVisible] = useState(false);

  const { workOrderId } = useParams();

  const {
    bolLoading,
    shipmentDetails,
  } = useSelector((state) => state.postShipment || {});

  const dispatch = useDispatch();

  const formatShipmentDate = (shipment) => {
    if (!shipment) return '---';
    const { start_date, created_at, name } = shipment;
    
    // Try start_date or created_at first
    if (start_date || created_at) {
      const d = dayjs(start_date || created_at);
      if (d.isValid()) return d.format("YYYY-MM-DD");
    }
    
    // Fallback: try to extract from name "FBA STA (05/02/2026 16:39)-TMB8"
    if (name) {
      const match = name.match(/\((\d{2})\/(\d{2})\/(\d{4})/);
      if (match) {
        const [_, month, day, year] = match;
        const parsed = dayjs(`${year}-${month}-${day}`);
        if (parsed.isValid()) return parsed.format("YYYY-MM-DD");
      }
    }
    
    return '---';
  };

  const getShipmentMode = (shipmentId) => {
    const shipment = shipments.find(s => s.amazon_shipment_id === shipmentId) || {};
    const detail = transportationDetails.find(({ shipmentId: id }) => id === shipmentId) || {};
    const mode = shipment.shipment_type || detail.shipmentType || detail.shipment_type || shipmentType || '';
    
    if (mode === 'GROUND_SMALL_PARCEL' || mode === 'SP') return 'SP';
    return 'LTL';
  };

  const boxLabelPageOptions = [
    { label: 'Letter 2', value: 'PackageLabel_Letter_2' },
    { label: 'Letter 4', value: 'PackageLabel_Letter_4' },
    { label: 'Letter 6', value: 'PackageLabel_Letter_6' },
    { label: 'A4 2', value: 'PackageLabel_A4_2' },
    { label: 'A4 4', value: 'PackageLabel_A4_4' },
    { label: 'Plain Paper', value: 'PackageLabel_Plain_Paper' },
    { label: 'Thermal', value: 'PackageLabel_Thermal' },
    { label: 'Thermal Unified', value: 'PackageLabel_Thermal_Unified' },
    { label: 'Thermal Non-PCP', value: 'PackageLabel_Thermal_NonPCP' },
  ];

  const getCarrierType = (shipmentId) => {
    const shipment = shipments.find(s => s.amazon_shipment_id === shipmentId) || {};
    const detail = transportationDetails.find(({ shipmentId: id }) => id === shipmentId) || {};
    return shipment.carrier_type || detail.carrierType || detail.carrier_type || '';
  };

  const printBoxLabels = (shipmentId) => {
    setGetBoxLabelsLoading(true);
    const body = {
      shipmentId,
      PageType: boxLabelPageType,
      LabelType: 'UNIQUE',
      PageStartIndex: 0
    };
    dispatch(GetLabels(body)).then(() => {
      setGetBoxLabelsLoading(false);
    })
  }

  const printCarrierLabels = (shipmentId) => {
    setGetCarrierLabelsLoading(true);
    const body = {
      shipmentId,
      PageType: boxLabelPageType,
      LabelType: 'BARCODE_2D',
      PageStartIndex: 0
    };
    dispatch(GetLabels(body)).then(() => {
      setGetCarrierLabelsLoading(false);
    })
  }

  const printPalletLabels = (shipmentId) => {
    setPalletsLoading((prev) => ({ ...prev, [shipmentId]: true }));
    setGetPalletLabelsLoading(true);
    const body = {
      shipmentId,
      PageType: palletLabelPageType,
      LabelType: 'PALLET',
      PageStartIndex: 0
    };
    dispatch(GetLabels(body)).then(() => {
      setGetPalletLabelsLoading(false);
      setPalletsLoading((prev) => ({ ...prev, [shipmentId]: false }));

    })
  }

  const downloadBillOfLading = (shipmentId) => {
    setAllBolLoading((prev) => ({ ...prev, [shipmentId]: true }));
    dispatch(DownloadBillOfLading(shipmentId)).then(() => {
      setAllBolLoading((prev) => ({ ...prev, [shipmentId]: false }));
    })
  };

  const {
    source_name,
    source_address_line_1,
    source_city,
    source_state_or_province,
    source_postal_code,
    source_country_code,

    destination_name,
    destination_address_line_1,
    destination_city,
    destination_state_or_province_code,
    destination_postal_code,
    destination_country_code,
  } = shipments?.[0] || {};

  const sourceAddress = `${source_name || ''}, ${source_address_line_1 || ''}, ${source_city || ''}, ${source_state_or_province || ''} ${source_postal_code || ''}, ${source_country_code || ''}`;
  const destinationAddress = `${destination_name || ''}, ${destination_address_line_1 || ''}, ${destination_city || ''}, ${destination_state_or_province_code || ''} ${destination_postal_code || ''}, ${destination_country_code || ''}`;

  return (
    <StepFourWrapper>
      <div className={`${printBoxGlobal ? 'show-global' : 'hide-global'}`}>
        {/* Step Header with Actions */}
        <div className="step-header-actions" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '1.5rem' }}>
       
          {packingMethod === 'pack_now' && (
            <Button
              className="pack-scan-button-primary"
              text="📦 Pack & Scan"
              onClick={() => setPackScanVisible(true)}
              style={{ 
                background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                color: 'white',
                border: 'none',
                fontWeight: 700,
                borderRadius: '10px',
                padding: '10px 20px',
                boxShadow: '0 4px 12px rgba(37, 99, 235, 0.25)',
                cursor: 'pointer'
                
              }}
            />
          )}
        </div>

        {!printBoxGlobal ? <>
          <div className='items-wrapper-main'>
            <div className='items'>
              <p>Name</p>
              <p>{shipments[0]?.name || ''}</p>
            </div>
            <div className='items'>
              <p>Date</p>
              <p>{formatShipmentDate(shipments[0])}</p>
            </div>
            <div className='items'>
              <p>ID</p>
              <p>{shipments[0]?.amazon_shipment_confirmation_id || shipments[0]?.amazon_shipment_id || ''}</p>
            </div>
            <div className='items'>
              <p>Amazon Reference ID</p>
              <p>{shipments[0]?.amazon_reference_id || shipments[0]?.amazon_shipment_confirmation_id || '---'}</p>
            </div>
            <div className='items'>
              <p>Ship From</p>
              <p>{sourceAddress || ''}</p>
            </div>
            <div className='items'>
              <p>Ship To</p>
              <p>{destinationAddress || ''}</p>
            </div>
          </div>
          <div className='select-overlay-wrappers'>
            {getShipmentMode(shipments[0]?.amazon_shipment_id) === 'SP' ? (
              <div className='select-overlay-wrappers' style={{ flexWrap: 'wrap' }}>
                <div style={{ width: '100%', marginBottom: '4px' }}>
                  <ReactSelect
                    options={boxLabelPageOptions}
                    value={boxLabelPageOptions.find(opt => opt.value === boxLabelPageType)}
                    onChange={(opt) => setBoxLabelPageType(opt.value)}
                    placeholder="Select Page Type"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 }),
                      control: (base) => ({
                        ...base,
                        height: '38px',
                        minHeight: '38px',
                        borderRadius: '4px',
                        borderColor: '#E8ECF1',
                        fontWeight: 400,
                        boxShadow: 'none',
                        '&:hover': { borderColor: '#1565D8' }
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        height: '38px',
                        padding: '0 12px',
                        display: 'flex',
                        alignItems: 'center'
                      }),
                      indicatorsContainer: (base) => ({
                        ...base,
                        height: '38px',
                      }),
                      input: (base) => ({
                        ...base,
                        margin: 0,
                        padding: 0
                      })
                    }}
                  />
                </div>
                <div className='select-items'>
                  <Button
                    disabled={getBoxLabelsLoading}
                    className="default-billing"
                    text="Download Box Labels"
                    onClick={() => printBoxLabels(shipments[0]?.amazon_shipment_id)}
                  />
                </div>
                <Button
                  disabled={getCarrierLabelsLoading}
                  className="default-billing"
                  text="Download Carrier Labels"
                  onClick={() => printCarrierLabels(shipments[0]?.amazon_shipment_id)}
                />
              </div>
            ) : (
              <>
                <div className='select-items'>
                  <Button
                    disabled={getPalletLabelsLoading}
                    className="default-billing"
                    text="Download Pallets Labels"
                    onClick={() => printPalletLabels(shipments[0]?.amazon_shipment_id)}
                  />
                </div>
                <Button
                  disabled={bolLoading}
                  onClick={() => downloadBillOfLading(shipments[0]?.amazon_shipment_id)}
                  className="default-billing"
                  text="Download Bill of Lading"
                />
              </>
            )}
          </div>
        </>
          :
          <div className='cards-group-wrapper'>
            {shipments && shipments?.map((shipmentDetails, shipmentIndex) => {
              const shipmentId = shipmentDetails?.amazon_shipment_id;
              const amazonShipmentConfirmationId = shipmentDetails?.amazon_shipment_confirmation_id;
              const isPalletsLoading = palletsLoading[shipmentId] || false;
              const isBolLoading = allBolLoading[shipmentId] || false;

              const {
                source_name,
                source_address_line_1,
                source_city,
                source_state_or_province,
                source_postal_code,
                source_country_code,

                destination_name,
                destination_address_line_1,
                destination_city,
                destination_state_or_province_code,
                destination_postal_code,
                destination_country_code,
              } = shipmentDetails || {};

              const sourceAddress = `${source_name || ''}, ${source_address_line_1 || ''}, ${source_city || ''}, ${source_state_or_province || ''} ${source_postal_code || ''}, ${source_country_code || ''}`;
              const destinationAddress = `${destination_name || ''}, ${destination_address_line_1 || ''}, ${destination_city || ''}, ${destination_state_or_province_code || ''} ${destination_postal_code || ''}, ${destination_country_code || ''}`;

              return (
                <div className='cards-group' key={shipmentIndex}>
                  <h6>{ amazonShipmentConfirmationId || shipmentId }</h6>
                  <div className='items-wrapper-main'>
                    <div className='items'>
                      <p>Name</p>
                      <p>{shipmentDetails?.name || ''}</p>
                    </div>
                    <div className='items'>
                      <p>Date</p>
                      <p>{formatShipmentDate(shipmentDetails)}</p>
                    </div>
                    <div className='items'>
                      <p>ID</p>
                      <p>{shipmentDetails?.amazon_shipment_confirmation_id || shipmentDetails?.amazon_shipment_id || ''}</p>
                    </div>
                    <div className='items'>
                      <p>Amazon Reference ID</p>
                      <p>{shipmentDetails?.amazon_reference_id || shipmentDetails?.amazon_shipment_confirmation_id || '---'}</p>
                    </div>
                    <div className='items'>
                      <p>Ship From</p>
                      <p>{sourceAddress || ''}</p>
                    </div>
                    <div className='items'>
                      <p>Ship To</p>
                      <p>{destinationAddress || ''}</p>
                    </div>
                  </div>
                  <div className='select-overlay-wrappers flex'>
                    <div className='select-items-buttons'>
                      {getShipmentMode(shipmentId) === 'SP' ? (
                        <>
                          <div style={{ gridColumn: 'span 2' }}>
                            <ReactSelect
                              options={boxLabelPageOptions}
                              value={boxLabelPageOptions.find(opt => opt.value === boxLabelPageType)}
                              onChange={(opt) => setBoxLabelPageType(opt.value)}
                              placeholder="Select Page Type"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                control: (base) => ({
                                  ...base,
                                  height: '38px',
                                  minHeight: '38px',
                                  borderRadius: '4px',
                                  borderColor: '#E8ECF1',
                                  fontWeight: 400,
                                  boxShadow: 'none',
                                  '&:hover': { borderColor: '#1565D8' }
                                }),
                                valueContainer: (base) => ({
                                  ...base,
                                  height: '38px',
                                  padding: '0 12px',
                                  display: 'flex',
                                  alignItems: 'center'
                                }),
                                indicatorsContainer: (base) => ({
                                  ...base,
                                  height: '38px',
                                }),
                                input: (base) => ({
                                  ...base,
                                  margin: 0,
                                  padding: 0
                                })
                              }}
                            />
                          </div>
                          <Button
                            disabled={getBoxLabelsLoading}
                            className="default-billing"
                            text="Download Box Labels"
                            onClick={() => printBoxLabels(shipmentId)}
                          />
                          <Button
                            disabled={getCarrierLabelsLoading}
                            className="billing-button"
                            text="Download Carrier Labels"
                            onClick={() => printCarrierLabels(shipmentId)}
                          />
                        </>
                      ) : (
                        <>
                          <Button
                            disabled={isPalletsLoading}
                            className="default-billing"
                            text="Download Pallets Labels"
                            onClick={() => printPalletLabels(shipmentId)}
                          />
                          <Button
                            disabled={isBolLoading}
                            onClick={() => downloadBillOfLading(shipmentId)}
                            className="billing-button"
                            text="Download Bill of Lading"
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )
            }
            )}
          </div>}

      </div>

      {/* Pack & Scan Modal */}
      <PackScanModal
        open={packScanVisible}
        onClose={() => setPackScanVisible(false)}
        workOrderId={workOrderId}
      />
    </StepFourWrapper>
  )
}

export default StepFour;
